import projectMetricValue from '../../helpers/portfolio/projectMetricValue'
import { daysColorClass, formatDayAge } from '../../utils/activityAge'

/**
 * Toont één meetwaarde uit projectMetricDefinitions.js — als kolomcel in het
 * projectenoverzicht en als tegel op de projectdetailpagina.
 *
 * Elke toestand krijgt een eigen teken: '?' als de tellingen niet opgehaald
 * konden worden, '…' zolang ze onderweg zijn, '—' als de vraag niet te
 * stellen is. Alleen een echt getal wordt als getal getoond.
 *
 * @param {object} props
 * @param {import('../../helpers/portfolio/projectMetricDefinitions').ProjectMetric} props.metric - welke meetwaarde
 * @param {Record<string, object> | null} props.byCompagnyId - tellingen per organisatie; null = nog geen antwoord
 * @param {string} props.compagnyId - de organisatie waar het om gaat
 * @param {boolean} [props.failed] - de serveraanroep is mislukt
 * @param {object} [props.project] - het CompagnyMeta-document, voor de contextvragen
 */
const ProjectMetricValue = ({ metric, byCompagnyId, compagnyId, failed = false, project = null }) => {

    const value = projectMetricValue(metric, { byCompagnyId, compagnyId, failed, project })

    if (value.state === 'error') {
        return <span className="project-metric__unknown" title="Deze telling kon niet opgehaald worden">?</span>
    }

    if (value.state === 'loading') {
        return <span className="project-metric__loading">…</span>
    }

    if (value.state === 'none') return <span>—</span>

    if (value.state === 'ratio') return <span>{value.text}</span>

    return (
        <span>
            {value.total}
            {value.days !== null && <span className={daysColorClass(value.days)}> ({formatDayAge(value.days)})</span>}
        </span>
    )
}

export default ProjectMetricValue
